// Header Drawer Menu Toggle Functionality

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('#Details-menu-drawer-container');
    this.summaries = this.querySelectorAll('.mobile-menu-drawer summary');

    this.setupMobileMenuToggle();
  }

  setupMobileMenuToggle() {
    this.summaries.forEach((summary) => {
      summary.addEventListener('click', (event) => {
        const details = summary.closest('.mobile-menu-drawer');
        const parentNav = summary.closest('.menu-drawer__navigation');

        // Check if the click target is a link that should navigate
        const clickedLink = event.target.closest('a.parent-menu-item-link');
        if (clickedLink && clickedLink.classList.contains('not-submenu')) {
          // This link has no submenu, allow navigation
          return; // Let the link work normally
        }

        // If clicked on a link with submenu, the pointer-events: none in CSS will prevent it
        // So we only handle the summary click for accordion behavior

        // Toggle submenu-open class on parent navigation
        if (parentNav) {
          // Check if this menu is opening or closing
          setTimeout(() => {
            if (details.hasAttribute('open')) {
              // Menu is opening - add submenu-open class
              parentNav.classList.add('submenu-open');
            } else {
              // Menu is closing - check if any other submenu is open
              const otherOpenMenus = parentNav.querySelectorAll('.mobile-menu-drawer[open]');
              if (otherOpenMenus.length === 0) {
                // No other menus are open, remove submenu-open class
                parentNav.classList.remove('submenu-open');
              }
            }
          }, 10);
        }

        // Close other open menus (accordion behavior - only one open at a time)
        const allDetails = this.querySelectorAll('.mobile-menu-drawer');
        allDetails.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.hasAttribute('open')) {
            otherDetails.removeAttribute('open');
          }
        });
      });
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);

// Additional functionality for handling clicks outside menu items
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuDrawers = document.querySelectorAll('.mobile-menu-drawer');

  mobileMenuDrawers.forEach((drawer) => {
    const summary = drawer.querySelector('summary');
    const submenu = drawer.querySelector('.menu-drawer__submenu');

    if (summary && submenu) {
      // Handle the toggle event
      drawer.addEventListener('toggle', function(e) {
        const parentNav = drawer.closest('.menu-drawer__navigation');

        if (drawer.open) {
          // Opening - add class
          if (parentNav) {
            parentNav.classList.add('submenu-open');
          }
        } else {
          // Closing - check if any other submenu is open
          if (parentNav) {
            const otherOpenMenus = parentNav.querySelectorAll('.mobile-menu-drawer[open]');
            if (otherOpenMenus.length === 0) {
              parentNav.classList.remove('submenu-open');
            }
          }
        }
      });
    }
  });
});
